/**
 * Step 18 — Handoff to /chat
 *
 * Spec: specs/onboarding-rebuild.md → Act 3 step 18
 *
 * Variant scaffolding retired 2026-05-14 — synthesis is production.
 */

import HandoffSynthesis from './Handoff.synthesis'

export default function HandoffStep({
  displayName,
  firstName,
  onContinue,
  firstConversationId,
  planTier,
}) {
  return (
    <HandoffSynthesis
      displayName={displayName || 'friend'}
      firstName={firstName}
      onContinue={onContinue}
      firstConversationId={firstConversationId}
      planTier={planTier}
    />
  )
}
